import { i18n } from "next-i18next"
import { z } from "zod"

// Custom validation for usernames
const usernameValidation = z.string().max(50)

export const signUpSchema = z
  .object({
    username: usernameValidation,
    email: z
      .string()
      .min(1, { message: i18n?.t("Email is required") })
      .email({
        message: i18n?.t("Must be a valid email")
      }),
    password: z
      .string()
      .min(1, {
        message: i18n?.t("Password is required")
      })
      .min(8, {
        message: i18n?.t("Password must be at least 8 characters")
      }),
    confirmPassword: z.string().min(1, {
      message: i18n?.t("Confirm Password is required")
    })
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: i18n?.t("Passwords must match"),
    path: ["confirmPassword"]
  })

export const signInSchema = z.object({
  email: z
    .string()
    .min(1, { message: i18n?.t("Email is required") })
    .email({
      message: i18n?.t("Must be a valid email")
    }),
  password: z.string().min(1, {
    message: i18n?.t("Password is required")
  })
})

export const userSchema = z.object({
  id: z.string().min(1),
  email: z.string().max(255).min(1),
  username: usernameValidation
})

export const updateUserSchema = z
  .object({
    settings: z.object({
      randomHighlightNotification: z.object({
        time: z.string().max(20),
        enabled: z.boolean()
      }),
      amazonDomain: z.string().max(20)
    }),
    username: usernameValidation.optional()
  })
  .strict()
